
import { Component, Vue } from 'vue-property-decorator'
import { ReporterService } from '@/services/index'
import TableHeader from '@/components/table_header/index.vue'

@Component({
    name: 'RepeatReporters',
    components: {
        TableHeader
    }
})
export default class extends Vue {
    private reporters = []
    private tableHeaderDecs: string = ''
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = true

    private mounted() {
        this.getReporters()
    }

    private async getReporters() {
        const params = { 
            page_index: this.pageIndex, 
            page_size: this.pageSize 
        }
        const result = await ReporterService.getGroups(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.reporters = result.data.list
            this.tableHeaderDecs = '重复的记者一共存在' + this.pageTotal + 
                '组，覆盖' + result.data.reporter_total + '个'
        }
        this.loading = false
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.getReporters()
        $backtop.scrollToTop()
    }
}
